import { useContext } from "react";

import { Portal } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { PageSizeContext } from "@/components/layout/PageSize";
import { BackDrop } from "@/components/pieces/BackDrop";
import { ScrollableModal } from "@/components/pieces/ScrollableModal";
import { PORTAL_Z_INDEX } from "@/css/constants";

interface MarketingVideoProps {
  videoId: number;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export function MarketingVideo({
  videoId,
  visible,
  setVisible,
}: MarketingVideoProps) {
  const { windowHeight, windowWidth } = useContext(PageSizeContext);
  const heightConstrained = windowWidth / windowHeight > 1.7;

  return (
    <Portal>
      <BackDrop
        visible={visible}
        zIndex={PORTAL_Z_INDEX}
        opacity={0.6}
        onClick={() => setVisible(false)}
      />
      <ScrollableModal
        visible={visible}
        onClose={() => setVisible(false)}
        verticallyCenter={true}
        canOutsideClickClose={true}
        style={{
          width: 1000,
          maxWidth: heightConstrained ? windowHeight * 1.7 : "100%",
        }}
      >
        <Box backgroundColor="#FFF" className="round-corners" p={24}>
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              src={`https://player.vimeo.com/video/${videoId}?h=9da8a199e4&amp;badge=0&amp;&amp;player_id=0&amp;app_id=58479&amp;autoplay=${
                visible ? "1" : "0"
              }&amp;autopause=${!visible ? "1" : "0"}`}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
            />
          </div>
          <script src="https://player.vimeo.com/api/player.js" />
        </Box>
      </ScrollableModal>
    </Portal>
  );
}
